export class InsuredInfo {
  // public 変数 ------------------------------------------------------------------------
  public surNameKana:	string = null;    // 氏名カナ（姓）
  public firstNameKana:	string = null;    // 氏名カナ（名）
  public dateOfBirth:	string = null;    // 生年月日
  public gender:		string = null;    // 性別
  // --------------------------------------------------------------------------------------
}
